import { LookupService } from './lookup.service';
import { SharePointService } from 'sp-office365-framework';
import { Injectable } from '@angular/core';
import * as CamlBuilder from 'camljs';
import { ListViewComponent } from 'sp-office365-layout/lib/src/app/layout/listview/listview.component';
import { formatDate } from '@angular/common';
import { TimeService } from 'src/app/main/services/time.service';
import { EMPTY, forkJoin, from, of, Subject } from 'rxjs';
import { expand, map, mergeMap, reduce, switchMap, takeUntil, toArray } from 'rxjs/operators';
import { createBatch } from '@pnp/sp/batching';

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    public startDate: Date;
    public endDate: Date;
    public userIds: number[] = [];
    public projectIds: number[] = [];
    public currentListView: ListViewComponent;
    public searchByAllTeamLeiterUsers: boolean;
    public cancelLoadItems$ = new Subject();


   fetchedItems;
   fetchedMitarbeiters;
   fetchedKostenrollens;
   

    get allCustomersSearchCamlQuery() {
        return new CamlBuilder()
            .Where()
            .TextField('Title')
            .Contains('<%searchText%>')
            .And()
            .NumberField('FSObjType')
            .EqualTo(0)
            .OrderByDesc('Modified')
            .ToString();
    }

    getProjectIdsFromLookUp(
        id: number,
        lookupField: string
    ): Promise<number[]> {
        return new Promise<number[]>((resolve, reject) => {
            this._sharepointService
                .getListItems({
                    title: 'Aufträge',
                    isDocumentLibrary: false,
                    camlQuery: new CamlBuilder()
                        .Where()
                        .LookupField(lookupField)
                        .Id()
                        .EqualTo(id)
                        .ToString(),
                })
                .then((results) => {
                    let projectIds: number[] = [];

                    results.forEach((result) => {
                        projectIds.push(result.Id);
                    });

                    resolve(projectIds);
                })
                .catch((err) => {
                    console.error(err);
                });
        });
    }

    constructor(
        private readonly _sharepointService: SharePointService,
        private readonly _timeService: TimeService
    ) {}

    startOfWeek(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        const diff =
            date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);

        return new Date(date.setDate(diff));
    }

    endOfWeek(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(
            this.startOfWeek(date).setDate(this.startOfWeek(date).getDate() + 6)
        );
    }

    startOfMonth(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(date.setDate(1));
    }

    endOfMonth(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    startOfYear(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(new Date(date.setMonth(0)).setDate(1));
    }

    endOfYear(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(new Date(date.setMonth(11)).setDate(31));
    }

    startOfQuarter(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        if (this.getQuarter(date) == 1) {
            return this.startOfMonth(new Date(date.setMonth(0)));
        } else if (this.getQuarter(date) == 2) {
            return this.startOfMonth(new Date(date.setMonth(3)));
        } else if (this.getQuarter(date) == 3) {
            return this.startOfMonth(new Date(date.setMonth(6)));
        } else if (this.getQuarter(date) == 4) {
            return this.startOfMonth(new Date(date.setMonth(9)));
        }
    }

    endOfQuarter(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        if (this.getQuarter(date) == 1) {
            return this.endOfMonth(new Date(date.setMonth(2)));
        } else if (this.getQuarter(date) == 2) {
            return this.endOfMonth(new Date(date.setMonth(5)));
        } else if (this.getQuarter(date) == 3) {
            return this.endOfMonth(new Date(date.setMonth(8)));
        } else if (this.getQuarter(date) == 4) {
            return this.endOfMonth(new Date(date.setMonth(11)));
        }
    }

    addDaysToDate(date: Date, days: number) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(date.setDate(date.getDate() + days));
    }

    getQuarter(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return Math.floor((date.getMonth() + 3) / 3);
    }

    getEndOfTheDay(date: Date) {
        // Remove time
        date = new Date(date.toDateString());

        return new Date(
            new Date(new Date(date.setHours(23)).setMinutes(59)).setSeconds(59)
        );
    }

    reset() {
        this.startDate = null;
        this.endDate = null;
        this.userIds = [];
        this.projectIds = [];
    }

    public changeQuery(filterLocally): void {
        if(filterLocally){     
           this.createTableData(this.fetchedItems,this.fetchedMitarbeiters,this.fetchedKostenrollens)     
        }
        else
        this.setData();
    }

    public setData(): void {
        this.cancelLoadItems$.next(undefined);
        this.currentListView.listComponent.sharePointTableComponent.loading = true;
      
        const list = this._sharepointService.web.lists.getByTitle('Zeiten');
        const dateChunks = this._timeService.getDateEqualChunksOptimized(this.startDate, this.endDate);
        const [batchedListBehavior, execute] = createBatch(list);
      
        const batchPromises: Promise<any[]>[] = [];
      
        dateChunks.forEach((chunk) => {
          const filter = `Datum ge datetime'${chunk.startDate.toISOString()}' and Datum lt datetime'${chunk.endDate.toISOString()}'`;
      
          const promise = list.using(batchedListBehavior).items
            .filter(filter)
            .select(
              "Id", "Title", "Created", "Datum", "Minuten", "Beschreibung", "Author/Id",
              "Author/Title", "Projekt/Title","Projekt/Id", "Aufgabe/Title", 'Projektnummer', 'Kosten'
            )
            .expand("Author", "Projekt", "Aufgabe")
            .orderBy("Modified", false) 
            .top(5000)()
            .catch((error) => {
              console.error('Error during batch operation:', error);
              return []; // Continue with others even if one fails
            });
      
          batchPromises.push(promise);
        });
      
        from(execute()).pipe(
          switchMap(() => Promise.all(batchPromises)),
          map(results => results.flat()),
          takeUntil(this.cancelLoadItems$),
          switchMap((items) => {
            let rUserIds = [];
            items.forEach((item) => rUserIds.push(item.Author.Id));
            rUserIds = [...new Set(rUserIds)];
      
            console.log(
              `%cLoaded report elements: ${items.length}`,
              'color: green;font-weight:bold;font-size:20px;'
            );
      
            return forkJoin([
              of(items),
              this._sharepointService.getListItems({
                title: 'Mitarbeiter',
                isDocumentLibrary: false,
                camlQuery: new CamlBuilder()
                  .Where()
                  .UserField('User')
                  .Id()
                  .In(rUserIds.length ? rUserIds : [-1])
                  .ToString(),
                recursiveAll: true,
              }),
              this._sharepointService.getListItems({
                title: 'Kostenrollen',
                isDocumentLibrary: false,
                camlQuery: new CamlBuilder()
                  .Where()
                  .NumberField('ID')
                  .NotEqualTo(0)
                  .ToString(),
                recursiveAll: true,
              })
            ]);
          })
        ).subscribe({
          next: ([items, mitarbeiters, kostenrollens]) => {
            this.fetchedItems=items;
            this.fetchedMitarbeiters=mitarbeiters;
            this.fetchedKostenrollens=kostenrollens;
            this.createTableData(this.fetchedItems,this.fetchedMitarbeiters,this.fetchedKostenrollens)
          },
          error: (err) => {
            console.error('Error in data loading:', err);
            this.currentListView.listComponent.sharePointTableComponent.loading = false;
          },
          complete: () => {
            console.log('Data loading complete');
            this.currentListView.listComponent.sharePointTableComponent.loading = false;
          }
        });
      }
      
    public createTableData(items,mitarbeiters, kostenrollens){
      const tableData = [];
      const rMitarbeiter = [...mitarbeiters];
      const rKostenrollen = [...kostenrollens];

        if(this.userIds.length)
        items = items.filter(item => this.userIds.includes(item?.Author?.Id));

        if(this.projectIds.length)
          items = items.filter(item => this.projectIds.includes(item?.Projekt?.Id));


      items.forEach((item) => {
        const hours = Math.round((item.Minuten * 100) / 60) / 100;
        const date = new Date(item.Datum);
        const data = {
          ID: item.Id,
          Projekt: item?.Projekt?.Title,
          Datum: formatDate(date, 'dd.MM.yyyy', 'de-DE'),
          OriginalDate: date,
          Projektnummer: item?.Projektnummer,
          Author: item?.Author?.Title,
          Aufgabe: item?.Aufgabe?.Title,
          Minuten: hours,
          Kosten: item?.Kosten,
          Beschreibung: item?.Beschreibung,
          Kostenrolle: '',
        };

        for (let i = 0; i < rMitarbeiter?.length; i++) {
          if (rMitarbeiter[i].UserId == item?.Author?.Id) {
            for (let j = 0; j < rKostenrollen?.length; j++) {
              if (rKostenrollen[j].Id == rMitarbeiter[i].KostenrolleId) {
                data.Kostenrolle = rKostenrollen[j].Abbreviation;
                break;
              }
            }
          }
        }

        tableData.push(data);
      });

      this.currentListView.listViewConfig.tableConfigs[0].config.data = tableData;
      this.currentListView.refresh();
    }

    public addUser(userId: number): void {
        this.userIds.push(userId);
    }

    public removeUser(userId: number): void {
        this.userIds = this.userIds.filter((_userId) => _userId !== userId);
    }

    public isDuplicateUser(userId: number): boolean {
        return this.userIds.some((_userId) => _userId === userId);
    }

    public addTableGroup(data: any): void {
        this.currentListView.listViewConfig.tableConfigs[0].config.groups.push(
            data
        );
    }

    public removeTableGroup(): void {
        const removeIndex =
            this.currentListView.listViewConfig.tableConfigs[0].config.groups
                .map((element) => element.field)
                .indexOf('Author');

        this.currentListView.listViewConfig.tableConfigs[0].config.groups.splice(
            removeIndex,
            1
        );
    }

    public triggerFilterData(filterLocally=false): void {
        if (this.currentListView) {
            this.changeQuery(filterLocally);
        }
    }
}
